/**
 * Reducer to manage user account related state
 */

import { ActionTypes as types } from '../constants'
import serverProps from '../lib/server-props'

const initialState = {
  griffinMetadata: serverProps.griffinMetadata,
  decimalSeparator: serverProps.decimalSeparator,
  groupSeparator: serverProps.groupSeparator,
  country: serverProps.country,
  accountType: serverProps.accountType, // User Account Type PERSONAL, PREMIER, BUSINESS
  isCFPBEnabled: serverProps.isCFPBEnabled, // Feature Config per country
  subscriptionType: serverProps.subscriptionType,
  language: serverProps.language,
  userHasXoomAccount: serverProps.userHasXoomAccount,
  showRecipientFirst: serverProps.recipientFirst,
  isAccountLinkedToXoom: serverProps.isAccountLinkedToXoom, // is user's PP account linked to Xoom (seamless login, etc)?
  hasConfirmedEmail: serverProps.hasConfirmedEmail, // {bool} does PP think the User has confirmed email? Cast the string to a boolean
  lastXoomCountrySentTo: serverProps.xoomLastCountrySentTo, // {Object(countryName, countryCode) | undefined}. Last country we sent to if Xoom was last transaction
  supportsXoom: serverProps.supportsSendingWithXoom,
  xoomBaseUrl: serverProps.xoomBaseUrl,
  payerPrimaryCurrencyCode: '',
}

/**
 * Reducer. Pure function that mutates this part of the store
 * and returns a new obj.
 */
export default function user(state = initialState, action) {
  switch (action.type) {
    case types.RECEIVED_COUNTRY_DATA:
      return {
        ...state,
        payerPrimaryCurrencyCode: action.data.payerPrimaryCurrencyCode,
      }
    case types.XB_RECEIVED_GRIFFIN_METADATA:
      // Add data to initial state for when RESET_TO_INITIAL action is dispatched
      initialState.griffinMetadata = action.data
      return {
        ...state,
        griffinMetadata: action.data,
      }
    default:
      return state
  }
}
